import { Clickable, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';

const Header = ({ watchingCount, isHost, endStream, isLive, closeView }) => {
  const { t } = useTranslation();

  return (
    <Row
      bg="rgba(0,0,0,0.5)"
      pos="absolute"
      wid="calc(100% - 64px)"
      top="0"
      pad="16px 32px"
      zIndex="2"
      between
      center
    >
      <Row>
        {isLive && (
          <Row bg={theme.SECONDARY} pad="2px 8px" noFlex>
            <Text col="#fff" c1 bold>
              {t('goLive.live')}
            </Text>
          </Row>
        )}
      </Row>

      <Text col="#fff">{t('goLive.watchingCount', { watchingCount })}</Text>

      <Row>
        {isHost ? (
          <Clickable onClick={endStream}>
            <Text col="#fff" bold>
              {t('goLive.end')}
            </Text>
          </Clickable>
        ) : (
          <Clickable onClick={closeView}>
            <Icon type="close" col="#fff" dimensions={14} />
          </Clickable>
        )}
      </Row>
    </Row>
  );
};

export default Header;
